import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * TODO:
 *    1. 大促标签增加 DONE 还需要确认大小，目前小程序的宽高明显计算有问题
 */
import { createBusinessComponent } from '../utils/create';
import TjSwipe from '../swipe';
import envHelper from '../utils/envHelper.js';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('a', {
      class: _vm.b(),
      style: _vm.layoutStyleCpd,
      attrs: {
        "href": _vm.navUrlCpd,
        "title": _vm.unit.unitName
      },
      on: {
        "click": _vm.unitClick
      }
    }, [_vm.unit.failType && _vm.failTextMaping["fail_" + _vm.unit.failType] ? _c('div', {
      class: _vm.b('failText')
    }, [_c('span', [_vm._v(_vm._s(_vm.failTextMaping["fail_" + _vm.unit.failType].split('，')[0]) + "，")]), _c('strong', [_vm._v(_vm._s(_vm.failTextMaping["fail_" + _vm.unit.failType].split('，')[1]))])]) : _vm._e(), _c('div', {
      class: _vm.b('picture'),
      style: _vm.imgLayoutStyleCpd
    }, [_vm.isShowSwipeCpd ? _c('div', {
      class: _vm.b('picture__swipe')
    }, [_c('tj-swipe', {
      class: _vm.b('picture__swipe__com'),
      attrs: {
        "indicator-color": "white",
        "show-indicators": false
      },
      on: {
        "change": _vm.swipeChange
      }
    }, _vm._l(_vm.unit.pictureList, function (image, index) {
      return _c('tj-swipe-item', {
        key: index
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: image,
          expression: "image"
        }],
        staticClass: "tjf-img-background",
        class: _vm.b('picture__img'),
        style: _vm.imgLayoutStyleCpd
      })]);
    }))], 1) : _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.unit.defaultPicture,
        expression: "unit.defaultPicture"
      }],
      staticClass: "tjf-img-background",
      class: _vm.b('picture__img')
    }), _vm._t("picture-full"), !_vm.isHiddenAllButtons && _vm.isShowVideo && _vm.unit.showHouseVideo ? _c('span', {
      class: _vm.b('video_play'),
      attrs: {
        "title": _vm.unit.unitName
      },
      on: {
        "click": _vm.unitClick
      }
    }) : _vm._e(), !_vm.isHiddenAllButtons ? _c('div', {
      class: _vm.b('link-area')
    }, [_vm.showTopListTag ? [_c('div', {
      class: _vm.b('top-list-tag'),
      on: {
        "click": function click($event) {
          $event.preventDefault();
          $event.stopPropagation();

          _vm.openUrlPage(_vm.unit.topListTag.jumpUrl);
        }
      }
    }, [_c('span', {
      class: _vm.b('top-list-tag_icon')
    }), _c('span', {
      class: _vm.b('top-list-tag_text')
    }, [_vm._v(_vm._s(_vm.unit.topListTag.text))]), _c('span', {
      class: _vm.b('top-list-tag_rank')
    }, [_vm._v("No." + _vm._s(_vm.unit.boardRank))])])] : _vm._e(), _vm.showExtension ? [_c('div', {
      class: [_vm.b('top-list-tag'), _vm.b('advert-recommend')],
      style: {
        backgroundColor: _vm.unit.houseAdvert.flowBadge.background.color
      }
    }, [_c('span', {
      class: [_vm.b('top-list-tag_icon'), _vm.b('advert-recommend_icon')]
    }), _c('span', {
      class: _vm.b('advert-recommend_text'),
      style: {
        color: _vm.unit.houseAdvert.flowBadge.color
      }
    }, [_vm._v("\n            " + _vm._s(_vm.unit.houseAdvert.flowBadge.text) + "\n          ")])])] : _vm._e(), _vm.showPromotion ? _c('img', {
      class: _vm.b('promotion-tag'),
      attrs: {
        "src": _vm.unit.promotionPicUrl
      }
    }) : _vm._e()], 2) : _vm._e(), !_vm.isHiddenAllButtons ? _c('div', {
      class: _vm.b('bottom-info')
    }, [_c('div', {
      class: _vm.b('bottom-info_left')
    }, [_vm.isShowComment && _vm.unit.commentBrief && _vm.unit.commentBrief.overall ? _c('div', {
      class: _vm.b('comment-score')
    }, [_c('strong', {
      class: _vm.b('comment-score_score')
    }, [_vm._v(_vm._s(_vm.unit.commentBrief.overall) + "分")]), _vm.unit.commentBrief.commentBrief ? _c('span', {
      staticClass: "tj-ellipsis",
      class: _vm.b('comment-score_commentBrief')
    }, [_vm._v(_vm._s(_vm.unit.commentBrief.commentBrief))]) : _vm._e()]) : _vm._e()]), _c('div', {
      class: _vm.b('bottom-info_right')
    }, [_vm.isShowVR && _vm.unit.showHouseVR ? _c('i', {
      class: _vm.b('vr')
    }) : _vm._e(), _vm.isShowSwipeCpd ? _c('div', {
      class: _vm.b('indicators')
    }, [_vm._v("\n          " + _vm._s(_vm.currentSwipeIndex + 1 + '/' + _vm.unit.pictureList.length) + "\n        ")]) : _vm._e()])]) : _vm._e(), !_vm.isHiddenAllButtons ? _c('div', {
      class: _vm.b('button-area')
    }, [_vm.isShowAvatar ? _c('a', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.unit.defaultPicture,
        expression: "unit.defaultPicture"
      }],
      class: _vm.b('avator'),
      attrs: {
        "href": _vm.getFullPath("/fangdong/" + _vm.unit.hotleId + ".htm?unitid=" + _vm.unit.unitId)
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.landlordClick($event);
        }
      }
    }, [_c('span', {
      class: _vm.b('avator-box'),
      style: {
        backgroundImage: "url(" + _vm.unit.logoUrl + ")"
      }
    }, [_c('img', {
      class: _vm.b('avator-image'),
      attrs: {
        "src": _vm.unit.logoUrl
      }
    })]), _vm.unit.great ? _c('i', {
      class: _vm.b('avator-badge')
    }) : _vm._e()]) : _vm._e(), _vm.isShowFavorite ? _c('a', {
      class: _vm.b('favorite'),
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.favoriteClick($event);
        }
      }
    }, [_c('span', {
      class: _vm.b(_vm.unit.isFavorite ? 'favorite-active' : 'favorite-btn')
    }), _vm.unit.favoriteCount ? _c('span', {
      class: _vm.b('favorite-num')
    }, [_vm._v(_vm._s(_vm.formatNumber(_vm.unit.favoriteCount)))]) : _vm._e()]) : _vm._e(), _vm.isShowComment && _vm.unit.commentBrief && _vm.unit.commentBrief.totalCount ? _c('a', {
      class: _vm.b('comment-count'),
      attrs: {
        "href": _vm.getFullPath(_vm.commentDetailPath)
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.commentClick($event);
        }
      }
    }, [_c('span', {
      class: _vm.b('comment-count-btn')
    }), _c('span', {
      class: _vm.b('comment-count-num')
    }, [_vm._v(_vm._s(_vm.formatNumber(_vm.unit.commentBrief.totalCount)))])]) : _vm._e()]) : _vm._e()], 2), _c('div', {
      class: [_vm.b('info'), _vm.unit.failType && 'grayFilter']
    }, [_vm.unit.unitSummeries && _vm.unit.unitSummeries.length ? _c('div', {
      class: [_vm.b('info__desc')]
    }, [_c('div', {
      class: [_vm.b('info__desc__wrap'), 'tj-ellipsis']
    }, [_vm._l(_vm.unit.unitSummeries, function (item) {
      return [item.textType === 'UNITINFOR' && _vm.isShowBusinessDistrict ? _c('span', {
        key: item.textType,
        class: _vm.b('info__desc__text', {
          UNITINFOR: true
        })
      }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")]) : _vm._e()];
    }), _vm._l(_vm.getUnitSummeriesCpd, function (item, index) {
      return [_c('span', {
        key: item.textType,
        class: _vm.b('info__desc__text'),
        style: _vm.summeriesTagStyle(item)
      }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")]), index < _vm.getUnitSummeriesCpd.length - 1 ? _c('span', {
        key: 'tag-dot_' + index,
        staticClass: "tag-dot"
      }, [_vm._v("·")]) : _vm._e()];
    })], 2)]) : _vm._e(), _c('div', {
      ref: "unitName",
      class: [_vm.b('info__title'), {
        ellipsis: _vm.unitNameEllipsis
      }]
    }, [_c('span', {
      class: {
        text: _vm.unitNameEllipsis
      },
      style: {
        marginLeft: _vm.unitNameEllipsis ? -(_vm.diamondEllipsisDotWidth + _vm.diamondWidth * _vm.unit.diamondLevel) + 'px' : 'none'
      }
    }, [_vm._v("\n        " + _vm._s(_vm.unit.unitName) + "\n      ")]), !_vm.unitNameEllipsis && _vm.unit.diamondLevel && _vm.isShowDiamond ? [_c('tj-rate', {
      attrs: {
        "size": 11,
        "void-icon": _vm.diamondIconUrl,
        "count": _vm.unit.diamondLevel
      }
    })] : _vm._e(), _vm.unitNameEllipsis ? _c('div', {
      staticClass: "ellipsis-box"
    }, [_c('span', {
      staticClass: "ellipsis-dot"
    }, [_vm._v("…")]), _c('tj-rate', {
      attrs: {
        "size": 11,
        "void-icon": _vm.diamondIconUrl,
        "count": _vm.unit.diamondLevel
      }
    })], 1) : _vm._e()], 2), Array.isArray(_vm.unit.houseTags) && _vm.unit.houseTags.length > 0 ? _c('div', {
      class: _vm.b('info__tags')
    }, [_vm._l(_vm.unit.houseTags, function (t, i) {
      return _c('span', {
        key: i,
        staticClass: "info__tag",
        class: {
          'tj-hairline--surround': _vm.haveTagBorder(t)
        },
        style: _vm.houseTagStyle(t)
      }, [_vm._v(_vm._s(t.text))]);
    }), _c('span', {
      class: _vm.b('info__tags__overlay')
    })], 2) : _vm._e(), _vm._t("price-right"), _c('div', {
      class: _vm.b('info__price')
    }, [_c('div', {
      staticClass: "card-footer"
    }, [_vm.unit.failType === 9 ? _c('div', {
      staticClass: "left"
    }, [_vm._v("\n          " + _vm._s(_vm.unit.priceMissingText) + "\n        ")]) : _vm.unit.finalPrice <= 0 ? _c('div', {
      staticClass: "left"
    }, [_vm._v("\n          " + _vm._s(_vm.unit.priceMissingText || '暂无价格') + "\n        ")]) : _c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "final-price"
    }, [_c('span', {
      staticClass: "mark"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.unit.finalPrice))]), _vm.unit.finalPriceUnit ? _c('span', {
      staticClass: "finalPriceUnit"
    }, [_vm._v(_vm._s(_vm.unit.finalPriceUnit))]) : _vm._e(), _vm.unit.finalPriceDisplayType === 1 ? _c('span', {
      staticClass: "separator"
    }, [_vm._v("/")]) : _vm._e(), _vm.unit.finalPriceDisplayType === 1 ? _c('span', {
      staticClass: "night"
    }, [_vm._v("晚")]) : _vm._e(), _vm.unit.displayOrigionPrice ? _c('span', {
      staticClass: "origion-price"
    }, [_vm._v("￥" + _vm._s(_vm.unit.productPrice))]) : _vm._e()]), _c('div', {
      staticClass: "final-price-right  tj-ellipsis"
    }, [_vm.unit.priceTipBadge && _vm.isShowPromotion ? _c('div', {
      staticClass: "dacu-text",
      style: _vm.priceTipBadgeStyle(_vm.unit.priceTipBadge)
    }, [_c('i', {
      staticClass: "icon-unit-sound"
    }), _c('span', {
      staticClass: "text "
    }, [_vm._v(_vm._s(_vm.unit.priceTipBadge.text))])]) : _vm._e(), _vm.unit.cleaningTipsText ? _c('div', {
      staticClass: "cleaning-tip"
    }, [_vm._v(_vm._s(_vm.unit.cleaningTipsText))]) : _vm._e(), !_vm.unit.cleaningTipsText && _vm.unit.urgencyTip ? _c('div', {
      staticClass: "urgency-tip"
    }, [_vm._v(_vm._s(_vm.unit.urgencyTip))]) : _vm._e()])])]), _vm.unit.promoContent && !_vm.unit.referencePriceDesc ? _c('div', {
      class: _vm.b('info__promotion')
    }, [_c('span', [_vm._v(_vm._s(_vm.unit.promoContent))])]) : _vm._e(), _vm.unit.referencePriceDesc ? _c('div', {
      class: _vm.b('info__reference_price')
    }, [_c('span', [_vm._v(_vm._s(_vm.unit.referencePriceDesc))])]) : _vm._e(), _vm.unit.houseAdvert && _vm.unit.houseAdvert.advertShowTag && _vm.unit.advertUnitType === 8 ? _c('div', {
      class: _vm.b('info__adver')
    }, [_c('span', [_vm._v(_vm._s(_vm.unit.houseAdvert.advertBadge.text))])]) : _vm._e()])], 2), _c('div', {
      class: _vm.b('pro-list-tag')
    }, [_vm.showPRO ? _c('div', {
      staticClass: "pro"
    }, [_c('img', {
      attrs: {
        "src": _vm.unit.platformStrictSelectInfo.img,
        "alt": ""
      }
    })]) : _vm._e(), _vm.showList ? _c('div', {
      staticClass: "list"
    }, [_c('div', {
      staticClass: "list-before"
    }, [_c('div', {
      staticClass: "nav"
    }, [_vm._m(0), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.unit.rankInfo.rank))])])]), _c('div', {
      staticClass: "list-center"
    }, [_c('div', {
      staticClass: "txt"
    }, [_vm._v(" " + _vm._s(_vm.rankName))])]), _c('div', {
      staticClass: "list-after"
    })]) : _vm._e(), _vm.showPROAndList ? _c('div', {
      staticClass: "proAndList"
    }, [_c('img', {
      staticClass: "pro",
      attrs: {
        "src": _vm.unit.platformStrictSelectInfo.imgWithOther,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "center"
    }, [_c('div', {
      staticClass: "nav"
    }, [_vm._m(1), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.unit.rankInfo.rank))]), _c('div', {
      staticClass: "txt"
    }, [_vm._v(" " + _vm._s(_vm.rankName))])])]), _c('div', {
      staticClass: "after"
    })]) : _vm._e()])]);
  },
  staticRenderFns: [function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "no"
    }, [_c('img', {
      attrs: {
        "src": "https://pic.tujia.com/upload/festatic/publicImages/TOC-2809_NO.png",
        "alt": ""
      }
    })]);
  }, function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "no"
    }, [_c('img', {
      attrs: {
        "src": "https://pic.tujia.com/upload/festatic/publicImages/TOC-2809_NO.png",
        "alt": ""
      }
    })]);
  }],
  name: 'unit-item-3',
  serverCacheKey: function serverCacheKey(props) {
    return props.unit.unitId;
  },
  props: {
    /**
     * 房屋数据，强制格式
     * @type {Object}
     */
    unit: {
      type: Object
    },

    /**
     * 房屋跳转地址,无地址自动跳转默认地址
     * @type {String}
     */
    unitUrl: {
      type: String
    },

    /**
     * 是否开启多张图片
     * @type {Boolean}
     */
    isSwipe: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示收藏
     * @type {Boolean}
     */
    isShowFavorite: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示头像
     * @type {Boolean}
     */
    isShowAvatar: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示标签配置
     * @type {Boolean}
     */
    isShowTags: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示促销信息
     * @type {Boolean}
     */
    isShowPromotion: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示品质认证信息
     * @type {Boolean}
     */
    isShowQualityCertification: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示商圈距离
     * @type {Boolean}
     */
    isShowBusinessDistrict: {
      type: Boolean,
      default: true
    },
    isShowVR: {
      type: Boolean,
      default: true
    },
    isShowComment: {
      type: Boolean,
      default: true
    },
    isShowVideo: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示商圈溢出转换省略号
     * @type {Boolean}
     */
    isEnableBusinessDistrictEllipsis: {
      type: Boolean,
      default: true
    },

    /**
     * 边框Radius
     * @type {String}
     */
    borderRadius: {
      type: String,
      default: '6px'
    },

    /**
     * 背景色
     * @type {String}
     */
    background: {
      type: String,
      default: '#fff'
    },

    /**
     * 隐藏所有可以点击的按钮
     * @type {Boolean}
     */
    isHiddenAllButtons: {
      type: Boolean,
      default: false
    },
    // fas 上报扩展数据
    fasExtendInfo: {
      type: Object,
      defualt: function defualt() {
        return {};
      }
    },
    // 是否使用SPA Router跳转
    isRouterPush: {
      type: Boolean,
      default: true
    },
    // 是否展示钻级
    isShowDiamond: {
      type: Boolean,
      default: false
    } // /**
    //  * 内间距
    //  * @type {String}
    //  */
    // padding: {
    //   type: String,
    //   default: '20px'
    // }

  },
  data: function data() {
    return {
      // 当前swipe索引
      currentSwipeIndex: 0,
      // 房东详情页 path
      landlordDetailPath: "/fangdong/" + this.unit.hotleId + ".htm?unitid=" + this.unit.unitId,
      // 点评详情页 path
      commentDetailPath: "/tbnb/commentlist?unitId=" + this.unit.unitId,
      // 房屋详情页 path
      unitDetailPath: "/detail/" + this.unit.unitId + ".htm",
      // 是否mounted状态
      isMounted: false,
      // 是否模拟文本溢出。
      unitNameEllipsis: false,
      // 钻石宽度
      diamondWidth: 13,
      diamondEllipsisDotWidth: 36,
      diamondIconUrl: 'https://pic.tujia.com/upload/festatic/publicImages/diamondLevel.png',
      // 不可预订状态文本映射
      failTextMaping: {
        fail_1: '不满足连住天数，请修改日期后继续预订',
        fail_3: '所选日期不可订，请修改日期后继续预订',
        fail_8: '所选房屋已满房，请修改日期后继续预订',
        fail_9: '当前房源暂无价格，请浏览其他房源继续预订'
      }
    };
  },
  computed: {
    /**
     * 计算属性: 房屋卡片layout的样式style
     * @returns {Object} style object
     */
    layoutStyleCpd: function layoutStyleCpd() {
      return {
        background: this.background
      };
    },

    /**
     * 计算属性: 图片样式Style
     * @returns {Object} style object
     */
    imgLayoutStyleCpd: function imgLayoutStyleCpd() {
      return {
        borderRadius: this.borderRadius
      };
    },

    /**
     * 计算属性: M站域名
     * @returns {String}
     */
    navUrlCpd: function navUrlCpd() {
      var url = '';

      if (this.unitUrl) {
        url = this.unitUrl;
      } else {
        if (this.isMounted) {
          // 根据环境获取当前的URL
          var env = envHelper.getTujiaEnv();

          if (env && env.indexOf('.') === -1) {
            env = '.' + env;
          }

          var protocol = 'http' + (env === 'dev' ? '' : 's');
          url = protocol + "://m" + env + ".tujia.com/detail/" + this.unit.unitId + '.htm';
          this.unit.unitId + '.htm';
        } else {
          url = 'https://m.tujia.com/detail/' + this.unit.unitId + '.htm';
        }
      }

      return url;
    },

    /**
     * 计算属性: 是否展示Swipe组件
     * @returns {String}
     */
    isShowSwipeCpd: function isShowSwipeCpd() {
      return !this.isHiddenAllButtons && this.isMounted && this.isSwipe && this.unit.pictureList && this.unit.pictureList.length > 0;
    },
    getUnitSummeriesCpd: function getUnitSummeriesCpd() {
      return this.unit.unitSummeries.filter(function (item) {
        return item.textType !== 'UNITINFOR';
      });
    },
    // 仅展示优选pro
    showPRO: function showPRO() {
      var _this$unit, _this$unit2, _this$unit2$rankInfo;

      var platformStrictSelectInfo = (_this$unit = this.unit) == null ? void 0 : _this$unit.platformStrictSelectInfo;
      return (platformStrictSelectInfo == null ? void 0 : platformStrictSelectInfo.platformStrictSelect) && (platformStrictSelectInfo == null ? void 0 : platformStrictSelectInfo.img) && !((_this$unit2 = this.unit) != null && (_this$unit2$rankInfo = _this$unit2.rankInfo) != null && _this$unit2$rankInfo.name);
    },
    // 仅展示榜单
    showList: function showList() {
      var _this$unit3, _this$unit4, _this$unit4$platformS;

      var rankInfo = (_this$unit3 = this.unit) == null ? void 0 : _this$unit3.rankInfo;
      return !((_this$unit4 = this.unit) != null && (_this$unit4$platformS = _this$unit4.platformStrictSelectInfo) != null && _this$unit4$platformS.platformStrictSelect) && (rankInfo == null ? void 0 : rankInfo.name) && (rankInfo == null ? void 0 : rankInfo.rank);
    },
    // 展示pro和榜单
    showPROAndList: function showPROAndList() {
      var _this$unit5, _this$unit6;

      var platformStrictSelectInfo = (_this$unit5 = this.unit) == null ? void 0 : _this$unit5.platformStrictSelectInfo;
      var rankInfo = (_this$unit6 = this.unit) == null ? void 0 : _this$unit6.rankInfo;
      return (platformStrictSelectInfo == null ? void 0 : platformStrictSelectInfo.platformStrictSelect) && (platformStrictSelectInfo == null ? void 0 : platformStrictSelectInfo.imgWithOther) && (rankInfo == null ? void 0 : rankInfo.name) && (rankInfo == null ? void 0 : rankInfo.rank);
    },
    rankName: function rankName() {
      var _this$unit7, _this$unit7$rankInfo;

      var rankName = (_this$unit7 = this.unit) == null ? void 0 : (_this$unit7$rankInfo = _this$unit7.rankInfo) == null ? void 0 : _this$unit7$rankInfo.name;

      if (this.showList) {
        var _rankName;

        if (((_rankName = rankName) == null ? void 0 : _rankName.length) > 13) {
          var _rankName2;

          rankName = ((_rankName2 = rankName) == null ? void 0 : _rankName2.slice(0, 13)) + "...";
        }

        return rankName;
      }

      if (this.showPROAndList) {
        var _rankName3;

        if (((_rankName3 = rankName) == null ? void 0 : _rankName3.length) > 10) {
          var _rankName4;

          rankName = ((_rankName4 = rankName) == null ? void 0 : _rankName4.slice(0, 10)) + "...";
        }

        return rankName;
      }

      return rankName;
    },
    // 展示topListTag（老榜单）
    showTopListTag: function showTopListTag() {
      var _this$unit8;

      return !this.showPRO && !this.showList && !this.showPROAndList && ((_this$unit8 = this.unit) == null ? void 0 : _this$unit8.topListTag);
    },
    // 展示推广引导
    showExtension: function showExtension() {
      var _this$unit9, _this$unit10, _this$unit10$houseAdv;

      return !this.showPRO && !this.showList && !this.showPROAndList && !((_this$unit9 = this.unit) != null && _this$unit9.topListTag) && ((_this$unit10 = this.unit) == null ? void 0 : (_this$unit10$houseAdv = _this$unit10.houseAdvert) == null ? void 0 : _this$unit10$houseAdv.flowBadge);
    },
    // 展示大促信息
    showPromotion: function showPromotion() {
      var _this$unit11;

      return !this.showPRO && !this.showList && !this.showPROAndList && ((_this$unit11 = this.unit) == null ? void 0 : _this$unit11.promotionPicUrl) && this.isShowPromotion;
    } // 后续增加打点恢复代码
    // indicatorCountCpd() {
    //   if (!this.unit || !this.unit.pictureList || this.unit.pictureList.length === 0) return 0;
    //   return this.unit.pictureList.length > 7 ? 7 : this.unit.pictureList.length;
    // }

  },
  mounted: function mounted() {
    this.isMounted = true;
    this.isShowDiamond && this.computeEllipsis();
  },
  methods: {
    // 图片切换
    swipeChange: function swipeChange(index) {
      this.currentSwipeIndex = index;

      this._tjTrack('UNIT-ITEM_IMAGES_SWIPE', {
        swipeIndex: index
      });
    },

    /**
     * 收藏点击事件
     */
    favoriteClick: function favoriteClick() {
      event.preventDefault(); // 未有前置数据前特殊处理

      if (this.unit.isFavorite === undefined || this.unit.isFavorite === null) {
        this.$set(this.unit, 'isFavorite', false);
      }

      this._tjTrack('UNIT-ITEM_FAVORITE_CLICK', {
        isFavorite: !this.unit.isFavorite
      });

      this.$emit('favoriteClick', this.unit);
    },

    /**
     * 点评点击事件
     */
    commentClick: function commentClick(event) {
      var _this = this;

      event.preventDefault();

      this._tjTrack('UNIT-ITEM_COMMENT_CLICK');

      if (this.$listeners.commentClick) {
        this.$emit('commentClick', this.unit, function () {
          _this.openPage(_this.commentDetailPath);
        });
      } else {
        this.openPage(this.commentDetailPath);
      }
    },

    /**
     * 房屋卡片点击事件
     */
    unitClick: function unitClick(event) {
      var _this$unit12,
          _this$unit12$allActiv,
          _this2 = this;

      event.preventDefault();
      var eventData = {
        diamondLevel: this.unit.diamondLevel,
        unitName: this.unit.unitName,
        price_from: this.unit.sourceChannel
      };
      var activeRedPacket = (_this$unit12 = this.unit) == null ? void 0 : (_this$unit12$allActiv = _this$unit12.allActiveAndRedPacket) == null ? void 0 : _this$unit12$allActiv.activeRedPacket;

      if (activeRedPacket) {
        var exposureActivity = activeRedPacket.map(function (item) {
          var _item$introduction;

          return {
            activityid: item.marketActivityId,
            activityname: item.title,
            activitydiscount: (_item$introduction = item.introduction) == null ? void 0 : _item$introduction.replace(/-￥/, '')
          };
        });

        if (exposureActivity != null && exposureActivity.length) {
          eventData.exposure_activity = exposureActivity.filter(function (item, index) {
            return index <= 1;
          });
          eventData.hit_activity = exposureActivity;
        }
      }

      this._tjTrack('UNIT-ITEM_CLICK', eventData);

      if (this.$listeners.click || this.$listeners.unitClick) {
        var eventName = this.$listeners.unitClick ? 'unitClick' : 'click';
        this.$emit(eventName, this.unit, function () {
          _this2.openPage(_this2.unitDetailPath);
        });
      } else {
        this.openPage(this.unitDetailPath);
      }
    },

    /**
     * 房东头像点击事件
     */
    landlordClick: function landlordClick(event) {
      var _this3 = this;

      event.preventDefault();

      this._tjTrack('UNIT-ITEM_LANDLORD_CLICK');

      if (this.$listeners.landLordClick) {
        this.$emit('landlordClick', this.unit, function () {
          _this3.openPage(_this3.landlordDetailPath);
        });
      } else {
        this.openPage(this.landlordDetailPath);
      }
    },
    // 后续增加打点恢复
    indicatorAutoBem: function indicatorAutoBem(bemClassName, positionIndex, activeIndex) {
      positionIndex = positionIndex - 1;
      var stateName = '';

      if (Math.abs(activeIndex - positionIndex) >= 2 && (positionIndex === 0 || positionIndex === this.indicatorCountCpd - 1)) {
        stateName = 'small';
      }

      if (activeIndex === positionIndex || positionIndex === this.indicatorCountCpd - 1 && activeIndex >= this.indicatorCountCpd - 1) {
        stateName = 'active';
      }

      return this.b(bemClassName, stateName);
    },
    summeriesTagStyle: function summeriesTagStyle(t) {
      // "textType": "REALPHOTO",
      if (t.textType === 'REALPHOTO') {
        return {
          color: '#ff9645'
        };
      }
    },
    haveTagBorder: function haveTagBorder(t) {
      var isHaveTagBorder = t.border && t.border.width > 0;
      return isHaveTagBorder;
    },
    houseTagStyle: function houseTagStyle(t) {
      return {
        color: t.color,
        backgroundColor: t.background.color
      };
    },

    /** 房屋卡片底部 价格 促销信息
     * @param {Object} style 接口样式
     * @return {Object} 符合vue风格的样式
     */
    priceTipBadgeStyle: function priceTipBadgeStyle(style) {
      if (style) {
        var color = style.color,
            gradient = style.gradient;
        return {
          color: color,
          borderRadius: '7px',
          backgroundImage: "linear-gradient(-270deg, " + gradient.endColor + " 1%, " + gradient.startColor + " 99%)"
        };
      }
    },

    /** 房屋卡片底部 图片标签
     * @param {Object} style 接口样式
     * @return {Object} 符合vue风格的样式
     */
    houseListTagStyle: function houseListTagStyle(style) {
      if (style) {
        var imageUrl = style.imageUrl,
            width = style.width,
            height = style.height;
        return {
          width: width / 2 + "px",
          height: height / 2 + "px",
          backgroundImage: "url(" + imageUrl + ")",
          backgroundSize: 'contain'
        };
      }
    },
    // 新版未使用
    topListTagStyle: function topListTagStyle(style) {
      if (style) {
        var color = style.color,
            gradient = style.gradient;
        return {
          color: color,
          borderRadius: '10px',
          backgroundImage: "linear-gradient(to right, " + gradient.endColor + " , " + gradient.startColor + ")"
        };
      }
    },
    // 房屋名称溢出计算
    computeEllipsis: function computeEllipsis() {
      var _this4 = this;

      var unitNameEle = this.$refs.unitName;

      if (unitNameEle && this.unit.diamondLevel) {
        this.$nextTick(function () {
          var textEle = unitNameEle.querySelector('span'); // 对文本内容会返回一个list, 每一行文本、省略号、省略号后面的内容都会被独立算作一个矩形数据

          var textEleRect = textEle.getClientRects();
          var rateEle = unitNameEle.querySelector('.tj-rate');
          var rateEleRect = rateEle.getBoundingClientRect(); // 如一段文本占用三行，chrome下的getClientRects长度是5， safari的getClientRects长度是3
          // chrome: 元素一：第一行文本整行矩形；元素二：第二行文本整行矩形：元素三：第三行文本整行矩形；元素四：省略号矩形；元素五：第三行换行文本矩形
          // safari: 元素一：第一行文本整行矩形；元素二：第二行文本整行矩形：元素三：第三行 换行 文本矩形

          if (textEleRect.length > 2 || textEleRect.length === 2 && rateEleRect.left - 5 === textEleRect[0].left) {
            var diamondWidth = _this4.diamondEllipsisDotWidth + _this4.diamondWidth * _this4.unit.diamondLevel;
            var emptySpanEle = document.createElement('span');
            emptySpanEle.style.display = "inline-block";
            emptySpanEle.style.width = diamondWidth + "px";
            textEle.appendChild(emptySpanEle);
            _this4.unitNameEllipsis = true;
          }
        });
      }
    },

    /**
     * 获取含有域名的完整链接
     * @param {String} path 不含域名的路径
     * @returns {type} 含有域名的完整链接
     */
    getFullPath: function getFullPath(path) {
      var url = '';

      if (this.isMounted) {
        // 根据环境获取当前的URL
        var env = envHelper.getTujiaEnv();

        if (env && env.indexOf('.') === -1) {
          env = '.' + env;
        }

        var protocol = 'http' + (env === 'dev' ? '' : 's');
        url = protocol + "://m" + env + ".tujia.com" + path;
      } else {
        url = "https://m.tujia.com" + path;
      }

      return url;
    },
    // 跳转页面
    openPage: function openPage(path) {
      if (this.isRouterPush) {
        this.$router.push(path);
      } else {
        window.location.href = this.getFullPath(path);
      }
    },
    // 跳转URL
    openUrlPage: function openUrlPage(url) {
      if (url) {
        window.location.href = url;
      }
    },

    /**
     * 行为上报
     * @param {String} eventName 自定义事件名称
     * @param {Object} eventData 指定上报字段
     */
    _tjTrack: function _tjTrack(eventName, eventData) {
      if (eventData === void 0) {
        eventData = {};
      }

      if (window._fas && eventName) {
        // 基础上报内容
        var _this$unit13 = this.unit,
            unitId = _this$unit13.unitId,
            unitName = _this$unit13.unitName,
            address = _this$unit13.address,
            productId = _this$unit13.productId,
            hotleId = _this$unit13.hotleId,
            finalPrice = _this$unit13.finalPrice,
            productPrice = _this$unit13.productPrice,
            checkInDate = _this$unit13.checkInDate,
            checkOutDate = _this$unit13.checkOutDate,
            cityId = _this$unit13.cityId,
            commentBrief = _this$unit13.commentBrief;

        if (commentBrief && commentBrief.overall) {
          eventData.commentScore = commentBrief.overall;
        } // 上报内容合并： 基础字段 + 指定字段 + 扩展字段


        eventData = _extends(eventData, {
          unitId: unitId,
          unitName: unitName,
          address: address,
          productId: productId,
          hotleId: hotleId,
          finalPrice: finalPrice,
          productPrice: productPrice,
          checkInDate: checkInDate,
          checkOutDate: checkOutDate,
          cityId: cityId
        }, this.fasExtendInfo); // 推广通

        eventData.isad = this.unit.adverUnit && this.unit.advertUnitType === 8;
        eventData.advertUnitType = this.unit.advertUnitType;

        window._fas.setCustomTrack({
          eventname: eventName,
          ext: eventData
        });
      }
    },

    /**
     * 格式化数字
     * @param {Number|String} num 参数描述
     * @returns {type} 返回值描述
     */
    formatNumber: function formatNumber(num) {
      var _num = parseInt(num, 10);

      if (_num.toString().length === 4) {
        return Math.floor(num / 1000) + 'k+';
      } else if (_num.toString().length >= 5) {
        return Math.floor(num / 10000) + 'w+';
      } else {
        return num;
      }
    }
    /**
     * 头像加载失败
     */
    // onAvatorLoadError(event) {
    //   const img = event.srcElement;
    //   img.addC = this.defaultImg
    // }

  },
  filters: {
    /**
     * 过滤器: tag style
     * @param {Object} tag tag对象
     * @returns {Object} style
     */
    tagStyleFilter: function tagStyleFilter(tag) {
      if (!tag) return null;
      return {
        color: tag.color,
        backgroundColor: tag.background && tag.background.color
      };
    }
  },
  component: {
    TjSwipe: TjSwipe
  }
});